// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__5p-NV","label":"CategoryService_label__3j5B_","location":"CategoryService_location__Rgas2"};